import type { CVConfig, CVProfile } from "./cv-mock-data";

interface CvPhotoStateActions {
  updateProfile: (updates: Partial<CVProfile>) => void;
  updateCVConfig: (updates: Partial<CVConfig>) => void;
}

/**
 * Keep a successful CV photo upload and its document visibility in sync.
 *
 * Uploading a photo is an explicit request to use it, so it must immediately
 * become visible even when the active template previously had showPhoto off.
 * Later Customize Preview taps only change showPhoto; they never clear the
 * stored avatar URL.
 */
export function revealUploadedCvPhoto(
  avatarUrl: string,
  { updateProfile, updateCVConfig }: CvPhotoStateActions,
) {
  updateProfile({ avatarUrl });
  updateCVConfig({ showPhoto: true });
}

/** Presets may choose a photo-free composition, but a real user upload wins. */
export function revealPhotoInPresetWhenUploaded<
  TConfig extends { showPhoto: boolean },
>(config: TConfig, avatarUrl?: string | null): TConfig {
  return avatarUrl ? { ...config, showPhoto: true } : config;
}
